import { useState } from 'react';
import { useNetworkReadyEffect } from './useNetworkReadyEffect';
import { useSnippetNamesQuery } from './useSnippetNamesQuery';
import { SNIPPET_NAME_QUERY_BATCH_SIZE } from '../constants';

export const useSnippetNames = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [snippetNames, setSnippetNames] = useState<string[]>([]);
  const [page, setPage] = useState(1);
  const {
    networkStatus,
    totalPages,
    snippetNames: latestSnippetNamesBatch,
  } = useSnippetNamesQuery(page, SNIPPET_NAME_QUERY_BATCH_SIZE);

  useNetworkReadyEffect(() => {
    // Add latest batch of snippet names to state
    setSnippetNames((currentSnippetNames) => [...currentSnippetNames, ...latestSnippetNamesBatch]);

    // If more pages need to be fetched, trigger new query by increasing page. Otherwise, stop loading.
    if (page < totalPages) setPage((currentPage) => currentPage + 1);
    else setIsLoading(false);
  }, networkStatus);

  return { snippetNames, isLoading };
};
